import { useEffect } from "react";
import { hideFocusRingsDataAttribute } from "./hideFocusRingsDataAttribute.mjs";
const hideFocusRings = () => document.body.setAttribute(hideFocusRingsDataAttribute, "true");
const showFocusRings = () => document.body.removeAttribute(hideFocusRingsDataAttribute);
const useHideFocusRings = (enabled = true) => {
  useEffect(() => {
    if (enabled) {
      window.addEventListener("keydown", showFocusRings);
      window.addEventListener("mousemove", hideFocusRings);
      return () => {
        window.removeEventListener("keydown", showFocusRings);
        window.removeEventListener("mousemove", hideFocusRings);
      };
    }
  }, [enabled]);
};
export {
  useHideFocusRings
};
